import React from "react";
import Unauthorized from "../../components/helper-components/misc/Unauthorized";
import Dashboard from "../../components/main-components/dashboard/Dashboard";

export function getMainRouteDefinitions(props) {
    return [
        {auth: true, navigationButtons: true, path: '/', component: <Dashboard />},
        {auth: false, navigationButtons: false, path: '/unauthorized', component: <Unauthorized {...props} />},
    ];
}